import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import MotionWrapper from '../../component/MotionWrapper';
import Main_Winter from '../../component/Winter/Main_Winter';
import Save_Date_Fall from '../../component/Fall/Save_Date_Fall';
import axios from 'axios';
import Info_Fall from '../../component/Fall/Info_Fall';
import Letter from '../../component/Spring/Letter';
import Dday_Spring from '../../component/Spring/Dday_Spring';
import Message_Spring from '../../component/Spring/Message_Spring';
import Location_Spring from '../../component/Spring/Location_Spring';
import Footer from '../../component/Footer';
import Loading from '../../component/Loading';
import Location_Desc from '../../component/Location/Location_Desc';
import Music from '../../component/Music';
import AccountList from '../../component/Account/AccountList';
import Sharing from '../../component/Sharing';
import GalleryList from '../../component/Gallery/GalleryList';
import Interview_Spring from '../../component/Spring/Interview_Spring';
import AccountList2 from '../../component/Account/AccountList2';
import CallInfo from '../../component/CallInfo';
import musicTitle from '../../asset/music/beauty.mp3'
import Information from '../../component/Information';

const JeJinEun = () => {
    const navigate = useNavigate(); 
    const { mainPage } = useParams();

    const API_URL = process.env.REACT_APP_API_URL;

    const [loading, setLoading] = useState(true);
    const [fontsLoaded, setFontsLoaded] = useState(false);

    const openTitle = "규민❤️진은 결혼식에 초대합니다";
    const openDesc = "Welcome to my wedding";
    const openThumb = "https://d39wt6wnedokd1.cloudfront.net/254/thumb.jpg";
    
    const placeTelNum = "055-760-1700";

    const lng = 128.092536845816;
    const lat = 35.1903618185496;

    const forCar = "진주 IC 진입 후, 진주교 통과 즉시 우회전하여 강변 따라 \n7분간 직진 (5.4km)";
    const forBus = "[진주시외버스터미널] 도보 5분 거리(450m)\n[진주고속버스터미널] 택시 이용 시 5분 소요(2km)";
    const forParking = "· 호텔 뒤 주차타워 이용 \n· 만차 시 주차타워 뒤쪽 지상 주차장 이용\n\n· 약 450대의 주차공간을 지원하오나 주말에는 주차장 및\n 교통이 혼잡한 지역이오니, 이 점 양지하시어 대중교통 \n이용을 권장드립니다.\n\n· 예식 당일 주차는 무료이며 따로 주차권은 필요 없으니 \n편하게 이용해 주십시오.";
    const forTrain2 = "[진주역] 택시 이용 시 20분 소요(7km)\n버스 이용 시 45분 소요(151번 탑승)";


    const [weddingData, setWeddingData] = useState({
        id:'',
        concept: '',
        weddingDate: '',
        invitationInfoId: '',
        brideName: '',
        groomName: '',
        brideNameEn: '',
        groomNameEn: '',
        year:'',
        month:'',
        date:'',
        dayOfWeek:'',
        time:'',
        place:'',
        address:'',
        mainImg:'',
        subImg:'',
        pointColor: '',
        btnFontColor: '',
        btnBgColor: '',
        isGuestBookOpen: ''
    });

    const conceptStyle = {
        concept: "WINTER",
        titleColor: "#000000",
        pointColor: "#000000",
        btnBgColor: "#000000",
        fontColor: "#ffffff",
        btnFontColor: "#ffffff",
        chatBgColor: "#F4F4F4",
        fontFamilyKo: "JejuMyeongjo",
        fontFamilyEn: "Milchella"
    }


    const parents = [
        {groom : "진용성 · 서윤희의 장남"},
        {bride : "박광익 · 장남옥의 차녀"}
    ]

    const title = "we invite you to our wedding";


    const msg1 = "우리 두 사람,\n사랑이라는 이름으로 \n하나의 길 위에 나란히 서게 되었습니다."
    const msg2 = "지금 이순간, \n소중한 분들과 가장 따뜻한 마음으로 \n이 여정을 함께 나누고 싶습니다."
    const msg3 = "작지만 정성껏 준비한 청첩장을 전합니다.\n함께해 주신다면, 더없이 큰 기쁨이 될 것 입니다.\n\n"


    const groomAccountList = [
        {
            role: "신랑",
            name: "박규민",
            bank: "카카오뱅크",
            accountNumber : "3333-10-6450292",
            isKakao : true,
            kakaoUrl : "https://qr.kakaopay.com/FXsxUtDCl"
        }
        ,{
            role: "신랑 부",
            name: "박철호",
            bank: "국민은행",
            accountNumber : "596801-04-265802",
            isKakao : false
        }
        // ,{
        //     role: "신랑 모",
        //     name: "박정옥",
        //     bank: "농협은행",
        //     accountNumber : "801032-52-002697",
        //     isKakao : false
        // }
    ]

    const brideAccountList = [
        {
            role: "신부",
            name: "제진은",
            bank: "카카오뱅크",
            accountNumber : "3333-17-9088180",
            isKakao : true,
            kakaoUrl : "https://qr.kakaopay.com/Ej8NDXES0"
        }
        ,{
            role: "신부 부",
            name: "제정범",
            bank: "농협은행",
            accountNumber : "356-5392-3651-93",
            isKakao : false
        }
        ,{
            role: "신부 모",
            name: "민희순",
            bank: "농협은행",
            accountNumber : "352-0649-0927-23",
            isKakao : false
        }
    ]

    const groomCallInfoList = [
        {
            role: "신랑",
            name: "정우진",
            call: "010-5467-5127"
        }
        ,
        {
            role: "신랑 부",
            name: "정창호",
            call: "010-3867-5127"
        },
        {
            role: "신랑 모",
            name: "김복경",
            call: "010-2425-3349"
        }
    ]

    const brideCallInfoList = [
        {
            role: "신부",
            name: "안현주",
            call: "010-2490-9377"
        }
        ,{
            role: "신부 부",
            name: "안인성",
            call: "010-2324-9377"
        }
        ,{
            role: "신부 모",
            name: "김미정",
            call: "010-7935-9377"
        }
    ]

    const account_explain = "따로 계좌번호를 여쭤보시는 수고를 덜기 위해 기입합니다. \n부담 안가지셨으면 좋겠습니다."

    const interviewContent = [
        {
            question : "우리의 설레였던 첫 만남 기억해?",
            groomAnswer: "너무 떨렸어",
            brideAnswer: "어떻게 잊어~"
        },
        {
            question : "결혼을 앞둔 소감이 어때?",
            groomAnswer: "두근두근",
            brideAnswer: "설렘 반 걱정 반"
        },
        {
            question : "서로에게 하고 싶은 말은?",
            groomAnswer: "잘 살아보자~",
            brideAnswer: "행복하자💛"
        },
        {
            question : "유부남/녀 기념 각오 한마디!",
            groomAnswer: "열심히 벌게",
            brideAnswer: "내조잘할게"
        },
        {
            question : "마지막으로 전하고 싶은 이야기는?",
            groomAnswer: "여러분",
            brideAnswer: "감사합니다💛"
        }
    ]

    const informationList =[
        {
            title : "화환 안내",
            content : "화환은 정중히 사양하오니 \n너른 양해 부탁드립니다."
        }
    ]

    const fetchInvitationInfoData = async () => {
        try {
            const response = await axios.get(`${API_URL}/_api/v1/invitation_info/${mainPage}`);
            if(response.status === 200){
                const [y, m, d] = response.data.data.weddingDate.split('-');

                setWeddingData(prevData => {
                    const newData = {
                        id: response.data.data.id,
                        concept: response.data.data.concept,
                        weddingDate: response.data.data.weddingDate,
                        invitationInfoId: response.data.data.id,
                        brideName: response.data.data.brideNameKo,
                        groomName: response.data.data.groomNameKo,
                        brideNameEn: response.data.data.brideNameEn,
                        groomNameEn: response.data.data.groomNameEn,
                        year: y,
                        month: m,
                        date: d,
                        dayOfWeek: response.data.data.dayOfWeek,
                        time: response.data.data.time,
                        place: response.data.data.place,
                        address: response.data.data.address,
                        mainImg: response.data.data.mainImg,
                        subImg: response.data.data.subImg,
                        pointColor: response.data.data.pointColor,
                        btnBgColor: response.data.data.btnBgColor,
                        btnFontColor: response.data.data.btnFontColor,
                        isGuestBookOpen: response.data.data.isGuestBookOpen
                    };
                    return newData;
                });
            } 
        } catch (error) {
            console.error("API 요청 실패:", error.response ? error.response.data : error.message);
        }
    };

    useEffect(() => {
        const fetchDataSequentially = async () => {
            if (!weddingData.weddingDate) {  
                await fetchInvitationInfoData();
            }
        };
        fetchDataSequentially();  // Call once on mount
    
        document.body.style.overflow = 'hidden';
    
        const timer = setTimeout(() => {
            document.body.style.overflow = '';
        }, 3000);
    
        return () => {
            clearTimeout(timer);
            document.body.style.overflow = '';
        };
    }, []);

    useEffect(() => {
        const fontLoadObserver = async () => {
            await document.fonts.ready; 
            setFontsLoaded(true); 
            setLoading(false);
        };
        if(!weddingData.weddingDate){
            fontLoadObserver();
        }
    }, []);

    const goToGuestBook = () => {
        navigate(`/${mainPage}/guest`); 
    };

    // 성을 제외하고 이름만 추출 ex. 가영
    const getFirstKoName = (fullName) => {
        const nameParts = fullName.split(''); 
        return nameParts.slice(1).join(''); 
    };

    // 성을 제외하고 이름만 추출 ex.Gayeong
    const getFirstNameEn = (fullName) => {
        const nameParts = fullName.split(' '); 
        const firstName = nameParts.slice(1).join(''); 
        return firstName.charAt(0).toUpperCase() + firstName.slice(1).toLowerCase();
    };

    return (
        <div>
            {loading || !fontsLoaded ? (
                <Loading color={"#000000"} loading={loading} />
            ) : (
                <>
                    <Music concept={conceptStyle.concept} musicTitle={musicTitle}/>
                    <Main_Winter width={"300px"} weddingData={weddingData} conceptStyle={conceptStyle} brideNameEn={getFirstNameEn(weddingData.brideNameEn)} groomNameEn={getFirstNameEn(weddingData.groomNameEn)} />
                    <Save_Date_Fall weddingData={weddingData} color={conceptStyle.titleColor} />
                    <Info_Fall conceptStyle={conceptStyle} weddingData={weddingData} />
                    <Letter title={title} msg1={msg1} msg2={msg2} msg3={msg3} conceptStyle={conceptStyle} />
                    {/* <CallInfo conceptStyle={conceptStyle} groomCallInfoList={groomCallInfoList} brideCallInfoList={brideCallInfoList}/> */}
                    <Dday_Spring isAttendFromClose={true} groomName={getFirstKoName(weddingData.brideName)} brideName={getFirstKoName(weddingData.groomName)} weddingData={weddingData} conceptStyle={conceptStyle}/>
                    <MotionWrapper initialY={50}>
                        <GalleryList fontFamilyKo={conceptStyle.fontFamilyKo} fontFamilyEn={conceptStyle.fontFamilyEn} color={conceptStyle.titleColor} weddingData={weddingData} initCount={9} photoWidth={"110px"} photoHeight={"150px"} gap={"3px"}/>
                    </MotionWrapper>
                    <MotionWrapper initialY={70}>
                        <AccountList conceptStyle={conceptStyle} groomAccountList={groomAccountList} brideAccountList={brideAccountList} account_explain={account_explain} />
                    </MotionWrapper>
                    <MotionWrapper initialY={70}>
                        <Message_Spring  weddingData={weddingData} goToGuestBook={goToGuestBook} weddingDate={weddingData.weddingDate} 
                            conceptStyle={conceptStyle} 
                            btnBgColor={weddingData.btnBgColor} btnFontColor={weddingData.btnFontColor} titleColor={weddingData.titleColor}
                            />
                    </MotionWrapper>
                    <MotionWrapper initialY={50}>
                        <Interview_Spring interviewContent={interviewContent} weddingData={weddingData} conceptStyle={conceptStyle}/>
                    </MotionWrapper>
                    <MotionWrapper initialY={50}>
                        <Location_Spring  weddingData={weddingData} conceptStyle={conceptStyle} lng={lng} lat={lat} placeTelNum={placeTelNum}/>
                    </MotionWrapper>
                        <Location_Desc forTrain2={forTrain2} forBus={forBus} forParking={forParking} forCar={forCar} conceptStyle={conceptStyle}/>
                        {/* <Information conceptStyle={conceptStyle} informationList={informationList} /> */}
                        <Sharing conceptStyle={conceptStyle} title={openTitle} description={openDesc} thumbImg={openThumb}/>
                        <Footer />
                </>
            )}
        </div>
    );
    
};

export default JeJinEun;